import { isOfMetaOrigin } from "../../../../../utils/marketing-url-params.js";
import useBaggageInfo from "./Items/BaggageInfo/useBaggageInfo.js";
import useGeniusRewardsInfo from "./Items/GeniusRewardsInfo/useGeniusRewardsInfo.js";
import useExtraProductsInfo from "./Items/ExtraProductsInfo/useExtraProductsInfo.js";
import useExtraProductsInfo2 from "./Items/ExtraProductsInfo2/useExtraProductsInfo2.js";
import useTicketTypeInfo from "./Items/TicketTypeInfo/useTicketTypeInfo.js";
import useFareRulesStatusInfo from "./Items/FareRulesStatusInfo/useFareRulesStatusInfo.js";
import useAtolInfo from "./Items/AtolInfo/useAtolInfo.js";
import useOneWayCombinationInfo from "./Items/OneWayCombinationInfo/useOneWayCombinationInfo.js";
import useRyanairHungaryInfo from "./Items/RyanairHungaryInfo/useRyanairHungaryInfo.js";
import useUserAgent from "../../../../../hooks/useUserAgent.js";
import useUpgradeFareInfoDesktop from "./Items/UpgradeFareInfo/useUpgradeFareInfo.desktop.js";
import useUpgradeFareInfoMobile from "./Items/UpgradeFareInfo/useUpgradeFareInfo.mobile.js";
import useFareRulesInfoWithPartials from "./Items/FareRulesInfoWithPartials/useFareRulesInfoWithPartials.js";
import { useMemo } from "react";
const useFlightDetailsInfoController = ({ flight, fetchStatus, baggagesExtrasOnly }) => {
    const { isMobile } = useUserAgent();
    const baggageInfo = useBaggageInfo(flight);
    const geniusRewardsInfo = useGeniusRewardsInfo(flight);
    const fareRulesInfoWithPartials = useFareRulesInfoWithPartials(flight);
    const extraProductsInfo = useExtraProductsInfo(flight, baggagesExtrasOnly);
    const extraProductsInfo2 = useExtraProductsInfo2(flight, baggagesExtrasOnly);
    const ticketTypeInfo = useTicketTypeInfo(flight);
    const fareRulesStatusInfo = useFareRulesStatusInfo(flight);
    const atolInfo = useAtolInfo(flight);
    const oneWayCombinationInfo = useOneWayCombinationInfo(flight);
    const ryanairHungaryInfo = useRyanairHungaryInfo(flight);
    const upgradeFareInfoMobile = useUpgradeFareInfoMobile(flight);
    const upgradeFareInfoDesktop = useUpgradeFareInfoDesktop(flight);
    const itemsMap = useMemo(() => ({
        baggageInfo,
        geniusRewardsInfo,
        fareRulesInfoWithPartials,
        upgradeFareInfoMobile: isMobile ? upgradeFareInfoMobile : undefined,
        upgradeFareInfoDesktop: isMobile ? undefined : upgradeFareInfoDesktop,
        extraProductsInfo,
        extraProductsInfo2,
        ticketTypeInfo,
        fareRulesStatusInfo,
        atolInfo,
        oneWayCombinationInfo,
        ryanairHungaryInfo
    }), [
        baggageInfo,
        geniusRewardsInfo,
        fareRulesInfoWithPartials,
        isMobile,
        upgradeFareInfoMobile,
        upgradeFareInfoDesktop,
        extraProductsInfo,
        extraProductsInfo2,
        ticketTypeInfo,
        fareRulesStatusInfo,
        atolInfo,
        oneWayCombinationInfo,
        ryanairHungaryInfo
    ]);
    const items = useMemo(() => Object.values(itemsMap).filter((i) => !!i), [itemsMap]);
    return {
        isLoading: fetchStatus === "loading" && !isOfMetaOrigin(),
        initialItems: [baggageInfo].filter((i) => !!i),
        items,
        itemsMap
    };
};
export default useFlightDetailsInfoController;
